import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~/components/ui/tooltip';

type ToolTipperProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  triggerClassName?: string;
};

export function Tooltipper({
  children,
  content,
  triggerClassName,
}: ToolTipperProps) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger className={triggerClassName} asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent>{content}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
